// 数据看板主页面组件
export default {
  // 新手引导
  finishButton: "完成",

  // 搜索框
  searchPlaceholder: "请输入你要搜索的案件",
  searchButton: "查询",

  // 消息提示
  dataLoading: "案件数据拉取中，预计需要一天时间，请耐心等待！",
  noSearchResult: "你搜索的案件暂无结果！",
  noData: "暂无",
};
